<mat-dialog-content>
  <div class="mat-dialog-body">
    <div class="mat-dialog-body-inner compliant-actions-dialog">
      <div class="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="109.998" height="96" viewBox="0 0 109.998 96">
          <g id="Group_12841" data-name="Group 12841" transform="translate(0 -30.999)">
            <path id="Path_88247" data-name="Path 88247"
              d="M108.29,107.863,66.214,37.527a12.928,12.928,0,0,0-22.429-.064L1.653,107.927a12.672,12.672,0,0,0,.129,12.736A12.762,12.762,0,0,0,12.867,127H97.14a12.792,12.792,0,0,0,11.15-19.136Z"
              transform="translate(0)" fill="#ffcf4c" />
            <path id="Path_88248" data-name="Path 88248"
              d="M309.226,120.663A12.762,12.762,0,0,1,298.14,127H256V31a12.731,12.731,0,0,1,11.215,6.528l42.076,70.336a12.635,12.635,0,0,1-.065,12.8Z"
              transform="translate(-201.001 0)" fill="#fbbd35" />
            <path id="Path_88249" data-name="Path 88249" d="M226,204.67h12.89v12.89H226ZM226,166h12.89v32.226H226Z"
              transform="translate(-177.446 -106.432)" fill="#8b602f" />
            <path id="Path_88250" data-name="Path 88250" d="M256,166h6.445v32.226H256Zm0,38.671h6.445v12.89H256Z"
              transform="translate(-201.001 -106.432)" fill="#7d4f1b" />
          </g>
        </svg>
        <h3 class="title">
          {{ 'fraudTasks.areYouSureYouWantToEscalateFraudCase' | translate}}
        </h3>
        <p class="sub-title">
          {{ 'fraudTasks.byConfirmingTheFraudCaseWillBeEscalated' | translate}}
        </p>
      </div>
      <form [formGroup]="formGroup">
        <h3 class="subtitle-form">{{"verificationTasks.escalationReasonPrompt" | translate}}</h3>
        <div class="fields-group" class="mb-2">
          <app-select-has-search controlName="institutionId" [formGroupBuilder]="formGroup"
            [recordsData]="institutionList" [dataLoading]="dataLoading" [required]="true"
            [errorMessage]="(!institutionList.length?'forms.noEscalationEntitiesConfiguredForFraudType':'forms.Required')| translate"
            [titleField]="'verificationTasks.selectConcernedAuthority'| translate"
            [searchTitle]="'forms.Search' | translate" [hasImage]="false" [key]="'id'"
            [valueKey]="true"></app-select-has-search>
        </div>
        <div class="fields-group">
          <mat-form-field class="mb-2">
            <mat-label>{{ 'verificationTasks.enterEscalationReason' | translate}}</mat-label>
            <textarea matInput formControlName="reason" maxlength="500"></textarea>
            <mat-error *ngIf="hasError('reason', 'required')">
              {{ "forms.Required" | translate }}
            </mat-error>
            <mat-hint>{{ "forms.Optional" | translate }}</mat-hint>
          </mat-form-field>
        </div>
        <div class="actions text-center">
          <button (click)="saveRecord()" mat-raised-button [disabled]="loading" class="mat-danger"
            [class.loading]="loading">
            {{ "verificationTasks.confirmComplaintEscalation" | translate }}
          </button>
          <button mat-button type="button" [disabled]="loading" matDialogClose class="btn-grey ml-3">
            {{ "forms.Cancel" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>